import { usePlatformStore } from '@/store-pinia/platform'

export function usePlatformProductContext() {
  const i18n = useI18n()
  const platformStore = usePlatformStore()

  const productDetailTitle = computed(() => (platformStore.isFunBookV2 ? i18n.t('funbook_product_detail') : i18n.t('product_detail')))

  const productDescriptionTitle = computed(() =>
    platformStore.isFunBookV2 ? i18n.t('funbook_product_description_title') : i18n.t('product_description_title')
  )

  return {
    productDetailTitle,
    productDescriptionTitle,
  }
}
